<template>
  <div>
    <el-row :gutter="20" style="padding-bottom: 10px">
      <el-col
        :span="4"
        style="display: flex; flex-direction: row; align-items: center"
      >
        <span style="flex: 3">所属电站:</span>
        <el-select
          style="flex: 7"
          v-model="suoshudianzhan"
          placeholder="请选择"
          @change="change_value"
          clearable
          @clear="getVinAccountList"
          filterable
        >
          <el-option
            v-for="item in powerStationList"
            :key="item.id"
            :label="item.stationName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col
        :span="4"
        label="车牌号"
        style="display: flex; flex-direction: row; align-items: center"
      >
        <span style="flex: 3">所属车牌:</span>
        <el-input
          style="flex: 7"
          placeholder="请输入车牌号"
          clearable
          v-model="queryInfo.carNumber"
          @clear="getVinAccountList"
          @change="current"
        >
        </el-input>
      </el-col>
      <el-col
        :span="4"
        label="车架号"
        style="display: flex; flex-direction: row; align-items: center"
      >
        <span style="flex: 3">所属车架:</span>
        <el-input
          style="flex: 7"
          placeholder="请输入车架号"
          clearable
          v-model="queryInfo.carvin"
          @clear="getVinAccountList"
          @change="current"
        >
        </el-input>
      </el-col>
      <el-col
        :span="4"
        label="路别"
        style="display: flex; flex-direction: row; align-items: center"
      >
        <span style="flex: 3">所属路别:</span>
        <el-input
          style="flex: 7"
          placeholder="请输入路别"
          clearable
          v-model="queryInfo.columns"
          @clear="getVinAccountList"
          @change="current"
        >
        </el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" @click="chaxun"
          >查询</el-button
        >
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-refresh-left" @click="chongzhi"
          >重置</el-button
        >
      </el-col>
    </el-row>
    <!-- 导入用户 -->
    <el-dialog
      title="导入"
      :visible.sync="importDialogVisible"
      width="660px"
      :close-on-click-modal="false"
      :before-close="onClose"
      @closed="onAfterClose"
    >
      <div v-loading="loading" class="dialog-content">
        <el-form ref="formRef" :model="formData" label-width="80px">
          <el-form-item label="选择文件" prop="fileList">
            <el-upload
              ref="upload"
              action="#"
              :accept="extAcceptStr"
              :auto-upload="false"
              :limit="limit"
              :file-list="formData.fileList"
              :on-change="onFileChange"
              :on-remove="onFileMove"
              :on-exceed="onFileExceed"
            >
              <div class="select-file">
                <p class="select-p">请选择上传文件</p>
                <el-button size="small" type="primary">选取文件</el-button>
              </div>
              <div slot="tip" class="el-upload__tip">
                {{ `支持${extAcceptStr} 格式的文件，大小不能超过10M` }}
              </div>
            </el-upload>
            <!-- <el-button type="text" @click="onDownload">模板下载</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <template slot="footer">
        <el-button
          type="primary"
          :loading="!!loading"
          :disabled="!formData.fileList.length > 0"
          @click="onSubmit"
          >导入
        </el-button>
        <el-button @click="importDialogVisible = false">取消</el-button>
      </template>
    </el-dialog>
    <!-- 充值/退款 -->
    <el-dialog
      title="充值/退款"
      :visible.sync="clis"
      width="30%"
      @close="clisClosed"
      append-to-body
      :close-on-click-modal="false"
    >
      <!-- 内容主体区域  -->
      <div>
        <el-radio-group
          v-model="radio"
          style="width: 100%; margin-bottom: 40px"
          @input="change_input"
        >
          <el-radio
            :label="item.radio"
            v-for="item in radio_value_cz_tk"
            :key="item.radio"
            :value="item.radio"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
        <!-- 充值/退款 -->
        <el-form
          :model="onAccountForm"
          ref="editPresentFormRef"
          label-width="124px"
        >
          <el-form-item label="总余额（元）" prop="money">
            <el-tag>￥{{ onAccountForm.money / 100 }}</el-tag>
          </el-form-item>
          <el-form-item :label="btn_title">
            <el-input-number
              v-model="num"
              controls-position="right"
              :precision="2"
              :step="0.1"
              :min="0"
            ></el-input-number
            ><span style="margin-left: 20px"> 元</span>
          </el-form-item>
        </el-form>
      </div>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="clisClosed">取 消</el-button>
        <el-button type="primary" v-debounce="clis_ok">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 卡记录 -->
    <el-dialog
      title="卡记录"
      :visible.sync="kajilu_dialoag"
      width="80%"
      @close="kajilu_dialoagClosed"
      append-to-body
    >
      <!-- 内容主体区域 -->
      <div>
        <el-radio-group
          v-model="ids_all"
          style="width: 100%"
          @input="change_input_card"
        >
          <el-radio
            :label="item.ids_all"
            v-for="item in radio_value_JL"
            :key="item.ids_all"
            :value="item.ids_all"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
        <div v-if="ids_all == 0">
          <!-- 消费记录 -->
          <el-table :data="expendList" border>
            <el-table-column
              align="center"
              label="ID"
              prop="payId"
              width="100px"
            ></el-table-column>
            <el-table-column
              align="center"
              label="卡号"
              prop="userNumber"
            ></el-table-column>
            <el-table-column
              align="center"
              label="更新前金额（元）"
              prop=" startMoney"
            >
              <template slot-scope="scope">
                <el-tag type="success"
                  >￥{{ jisuan(scope.row.startMoney, 100, 2) }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="变动金额（元）"
              prop="changMoney"
            >
              <template slot-scope="scope">
                <el-tag type="success"
                  >￥{{ jisuan(scope.row.changMoney, 100, 2) }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作类型"
              prop="usingType"
              width="100px"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="
                    scope.row.usingType == '0'
                      ? 'warning'
                      : scope.row.usingType == '1'
                      ? 'danger'
                      : scope.row.usingType == '2'
                      ? 'success'
                      : scope.row.usingType == '3'
                      ? 'default'
                      : 'warning'
                  "
                >
                  {{
                    scope.row.usingType == '0'
                      ? '消费'
                      : scope.row.usingType == '1'
                      ? '充值'
                      : scope.row.usingType == '2'
                      ? '退款'
                      : scope.row.usingType == '3'
                      ? '赠送'
                      : '欠费'
                  }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="新余额（元）"
              prop="newMoney"
            >
              <template slot-scope="scope">
                <el-tag type="success"
                  >￥{{ jisuan(scope.row.newMoney, 100, 2) }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="流水单号"
              prop="billCode"
              width="200px"
            ></el-table-column>
            <el-table-column
              align="center"
              label="创建时间"
              prop="createTime"
            ></el-table-column>
            <div v-if="expendList.length < 1">
              <el-empty :image-size="200"></el-empty>
            </div>
          </el-table>
          <!-- 分页导航区域 -->
          <el-pagination
            @size-change="expendSizeChange"
            @current-change="expendCurrentChange"
            :current-page="expendInfo.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="expendInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="expendTotal"
            background
          >
          </el-pagination>
        </div>
        <!-- 操作记录 -->
        <div v-if="ids_all == 1">
          <el-table :data="caozuojiluList" border>
            <el-table-column
              align="center"
              label="ID"
              prop="id"
              width="100px"
            ></el-table-column>
            <el-table-column
              align="center"
              label="用户姓名"
              prop="cardName"
            ></el-table-column>
            <el-table-column
              align="center"
              label="手机号"
              prop="cardTel"
            ></el-table-column>
            <el-table-column
              align="center"
              label="卡号"
              prop="physicalCode"
            ></el-table-column>
            <el-table-column
              align="center"
              label="操作时间"
              prop="updateTime"
            ></el-table-column>
            <div v-if="caozuojiluList.length < 1">
              <el-empty :image-size="200"></el-empty>
            </div>
          </el-table>
          <!-- 分页导航区域 -->
          <el-pagination
            @size-change="caozuojiluSizeChange"
            @current-change="caozuojiluCurrentChange"
            :current-page="caozuojiluInfo.page"
            :page-sizes="[8, 20, 50, 100]"
            :page-size="caozuojiluInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="caozuojiluTotal"
            background
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 添加&&编辑直充用户的对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="editDialogVisible"
      width="35%"
      @close="editDialogClosed"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        :model="vinAccountForm"
        :rules="vinAccountFormRules"
        ref="vinAccountFormRef"
        label-width="80px"
      >
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="12">
            <!-- 内容主体区域 required-->
            <el-form-item label="站点选择" prop="stationId">
              <el-select v-model="vinAccountForm.stationId" filterable>
                <el-option
                  v-for="item in stationList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.stationName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属公司" prop="companyName">
              <el-input v-model="vinAccountForm.companyName"></el-input>
            </el-form-item>
            <el-form-item label="路别：" prop="columns">
              <el-input v-model="vinAccountForm.columns"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车架号" prop="carvin">
              <el-input v-model="vinAccountForm.carvin"></el-input>
            </el-form-item>
            <el-form-item label="车牌号" prop="carNumber">
              <el-input v-model="vinAccountForm.carNumber"></el-input>
            </el-form-item>
            <el-form-item label="自编号：" prop="selfNumbering">
              <el-input v-model="vinAccountForm.selfNumbering"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogClosed">取 消</el-button>
        <el-button type="primary" v-debounce="editVinAccount">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 用户详情 -->
    <el-dialog
      title=""
      :visible.sync="Detaildialoag"
      width="60%"
      @close="DetailBtn"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="cardslist">
        <div class="top">
          <dl>
            <dt>
              <el-image
                style="width: 200px; height: 200px"
                :src="tupian + 'morentouxiang.png'"
                fit="scale-down"
              ></el-image>
            </dt>
            <dd>
              <!-- 横向排布 -->
              <li>
                <!-- p：横向排布，均分 -->
                <p>
                  <span>{{
                    listobj.columns == undefined ||
                    listobj.columns == null ||
                    listobj.columns == ''
                      ? '--'
                      : listobj.columns
                  }}</span>
                </p>
                <p>
                  <span>{{
                    listobj.selfNumbering == undefined ||
                    listobj.selfNumbering == null ||
                    listobj.selfNumbering == ''
                      ? '--'
                      : listobj.selfNumbering
                  }}</span>
                </p>
                <p>
                  <span>{{
                    listobj.carNumber == undefined ||
                    listobj.carNumber == null ||
                    listobj.carNumber == ''
                      ? '--'
                      : listobj.carNumber
                  }}</span>
                </p>
                <!-- <p><span></span></p> -->
              </li>
              <li>
                <p>
                  <span>用户来源</span><span>{{ listobj.stationName }}</span>
                </p>
                <p>
                  <span>所属公司</span><span>{{ listobj.companyName }}</span>
                </p>
                <p>
                  <span>加入时间</span><span>{{ listobj.createTime }}</span>
                </p>
                <!-- <p><span>最近一次充电时间</span><span>{{ listobj.lastTimeCharge }}</span></p> -->
              </li>
            </dd>
          </dl>
        </div>
        <div class="center">
          <dl>
            <dt>
              <el-image
                style="width: 200px; height: 200px"
                :src="tupian + '总费用.png'"
                fit="scale-down"
              ></el-image>
            </dt>
            <dd>
              <!-- 纵向排布 -->
              <li>
                <!-- p：纵向排布 -->
                <p></p>
              </li>
              <li
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                "
              >
                <!-- p：纵向排布 -->
                <p>
                  <span>总消费（元）</span
                  ><span>{{
                    jisuan(listobj.totalConsumptionMoney, 100, 2)
                  }}</span>
                </p>
                <p v-for="(item, index) in actlist" :key="index">
                  <span
                    @click="recodes(index)"
                    :style="{ color: activeIndex == index ? 'blue' : '#000' }"
                  >
                    {{
                      item == 0
                        ? '查看消费记录'
                        : item == 1
                        ? '查看充值记录'
                        : item == 2
                        ? '查看退款记录'
                        : item == 3
                        ? '查看赠送记录'
                        : item == 4
                        ? '查看欠费记录'
                        : '查看充电记录'
                    }}
                  </span>
                </p>
              </li>
            </dd>
          </dl>
        </div>

        <div class="footer">
          <!-- 纵向 -->
          <li>
            <p>
              <span>近30天的充电数据</span>
            </p>
            <p>
              <span>充电次数：</span>
              <span>{{ listobj.totalBillCount }}次</span>
            </p>
            <p>
              <span>充电电量：</span>
              <span>{{ jisuan(listobj.totalBillKwhs, 100, 4) }}度</span>
            </p>
            <p>
              <span>充电费用：</span>
              <span>{{ jisuan(listobj.totalBillMoney, 100, 2) }}元</span>
            </p>
          </li>
        </div>
      </div>
    </el-dialog>
    <!-- 充电历史订单 -->
    <el-dialog
      :visible.sync="dialoagBtn"
      width="80%"
      @close="MoneyDialoag2"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="Gomoney">
        <h4>充电历史订单</h4>
        <div class="moneylist">
          <dl>
            <p>订单金额（元）</p>
            <p>{{ jisuan(moren.totalBillMoney, 100, 2) }}</p>
          </dl>
          <dl>
            <p>电费金额（元）</p>
            <p>{{ jisuan(moren.totalChargeMoney, 100, 2) }}</p>
          </dl>
          <dl>
            <p>优惠金额（元）</p>
            <p>{{ jisuan(moren.totalDiscountMoney, 100, 2) }}</p>
          </dl>
          <dl>
            <p>服务费金额（元）</p>
            <p>{{ jisuan(moren.totalServiceMoney, 100, 2) }}</p>
          </dl>
          <dl>
            <p>实际收入（元）</p>
            <p>{{ shiji(moren.totalServiceMoney, moren.totalChargeMoney) }}</p>
          </dl>
          <dl>
            <p>充电电量（kwh）</p>
            <p>{{ jisuan(moren.totalBillKwhs, 100, 4) }}</p>
          </dl>
          <dl>
            <p>充电时间（分钟）</p>
            <p>{{ jisuan(moren.totalLengthTime, 60, 0) }}</p>
          </dl>
          <dl>
            <p>充电次数</p>
            <p>
              {{
                moren.totalBillCount == undefined ||
                moren.totalBillCount == null ||
                moren.totalBillCount == ''
                  ? '---'
                  : moren.totalBillCount
              }}
            </p>
          </dl>
        </div>
        <div class="list3" v-for="(item, index) in list3" :key="index">
          <h4
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              background: #e5e5e5;
              padding: 10px 0;
              font-size: 16px;
            "
          >
            <span style="flex: 1; padding-left: 10px; font-size: 14px">{{
              time_all(item)
            }}</span>
            <span style="flex: 2; display: flex; justify-content: center">
              Vin码：{{ item.carvin !== '' ? item.carvin : '--' }}</span
            >
            <span style="flex: 3; display: flex; justify-content: center">
              {{ item.createTime !== '' ? item.createTime : '--' }}</span
            >
            <span style="flex: 1; display: flex; justify-content: center"
              >ID:{{ item.id }}</span
            >
            <span style="flex: 1; display: flex; justify-content: center">
              充电方式:{{ item.id }}</span
            >
            <span style="flex: 2; display: flex; justify-content: center">
              充电桩编码:{{ item.pileCode }}</span
            >
          </h4>
          <div
            class="CONTENT"
            style="border: 1px solid gray; margin: 20px 0; border-radius: 15px"
          >
            <dl style="display: flex; flex-direction: row">
              <dt
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  flex: 1;
                "
              >
                <el-image
                  :src="tupian + 'morentouxiang.png'"
                  style="width: 200px; height: 200px"
                ></el-image>
                <span>充电卡用户ID：{{ item.id }}</span>
              </dt>
              <dd style="display: flex; flex-direction: column; flex: 9">
                <!-- 纵向均分两行 -->
                <div
                  class="li1"
                  style="flex: 1; display: flex; flex-direction: row"
                >
                  <!-- 横向，均分5列 -->
                  <div
                    class="hengxiang"
                    style="flex: 3; display: flex; flex-direction: column"
                  >
                    <span style="flex: 1; display: flex; align-items: center">{{
                      item.stationName
                    }}</span>
                    <span style="flex: 1; display: flex; align-items: center"
                      >充电口：{{ item.gunNumName }}</span
                    >
                    <span style="flex: 1; display: flex; align-items: center"
                      >充电时长：{{ jisuan(item.lengthTime, 60, 0) }}分钟</span
                    >
                  </div>
                  <div
                    class="hengxiang"
                    style="flex: 2; display: flex; flex-direction: column"
                  >
                    <span
                      style="flex: 1; display: flex; align-items: center"
                    ></span>
                    <span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: -15%;
                      "
                      >开始充电：{{ item.startTime }}</span
                    ><span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: -15%;
                      "
                      >结束充电：{{ item.endTime }}</span
                    >
                  </div>
                  <div
                    class="hengxiang"
                    style="flex: 2; display: flex; flex-direction: column"
                  >
                    <span
                      style="flex: 1; display: flex; align-items: center"
                    ></span>
                    <span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: 25%;
                      "
                      >开始SOC：{{ item.startSoc }}</span
                    ><span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: 25%;
                      "
                      >结束SOC：{{ item.endSoc }}</span
                    >
                  </div>
                  <!-- span 纵向 -->
                  <div
                    class="hengxiang"
                    style="flex: 1; display: flex; flex-direction: column"
                  >
                    <span style="flex: 1; display: flex; align-items: center"
                      >￥{{ jisuan(item.billMoney, 100, 2) }}</span
                    ><span style="flex: 1; display: flex; align-items: center"
                      >当前订单金额</span
                    >
                  </div>
                  <!-- span 纵向 -->
                  <div
                    class="hengxiang"
                    style="flex: 2; display: flex; flex-direction: column"
                  >
                    <span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: 25%;
                      "
                      >￥{{ shifu(item) }}</span
                    ><span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: 25%;
                      "
                      >实际订单金额</span
                    >
                  </div>
                </div>
                <div
                  class="li2"
                  style="flex: 1; display: flex; flex-direction: row"
                >
                  <div
                    class="hengxiang"
                    style="flex: 3; display: flex; flex-direction: column"
                  >
                    <span style="flex: 1; display: flex; align-items: center"
                      >尖电量：{{ jisuan(item.tipKwh, 100, 4) }}（度）</span
                    >
                    <span style="flex: 1; display: flex; align-items: center"
                      >峰电量：{{ jisuan(item.peakKwh, 100, 4) }}（度）</span
                    >
                  </div>
                  <div
                    class="hengxiang"
                    style="flex: 2; display: flex; flex-direction: column"
                  >
                    <span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: -15%;
                      "
                      >平电量：{{ jisuan(item.flatKwh, 100, 4) }}（度）</span
                    >
                    <span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: -15%;
                      "
                      >谷电量：{{ jisuan(item.valleyKwh, 100, 4) }}（度）</span
                    >
                  </div>
                  <div
                    class="hengxiang"
                    style="flex: 2; display: flex; flex-direction: column"
                  >
                    <span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: 25%;
                      "
                      >电费：{{ item.startSoc }}</span
                    ><span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: 25%;
                      "
                      >服务费：{{ item.endSoc }}</span
                    >
                  </div>
                  <!-- span 纵向 -->
                  <div
                    class="hengxiang"
                    style="flex: 1; display: flex; flex-direction: column"
                  >
                    <span style="flex: 1; display: flex; align-items: center">{{
                      jisuan(item.totalKwh, 100, 4)
                    }}</span
                    ><span style="flex: 1; display: flex; align-items: center"
                      >已充电量（度）</span
                    >
                  </div>
                  <!-- span 纵向 -->
                  <div
                    class="hengxiang"
                    style="flex: 2; display: flex; flex-direction: column"
                  >
                    <span
                      :style="{
                        color: item.payTypeName == '未支付' ? 'red' : 'gray',
                      }"
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: 25%;
                      "
                      >{{ item.payTypeName }}</span
                    >
                    <span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: 25%;
                        color: red;
                      "
                      v-if="item.payTypeName == '未支付'"
                      >结算</span
                    >
                    <span
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        margin-left: 25%;
                        color: orange;
                      "
                      >推送</span
                    >
                  </div>
                </div>
              </dd>
            </dl>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChange3"
          @current-change="handleCurrentChange3"
          :current-page="indexobj.page"
          :page-sizes="[8, 20, 50, 100]"
          :page-size="carInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total3"
          background
        >
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 充值、退款、欠费、消费 -->
    <el-dialog
      :visible.sync="recordTil"
      width="80%"
      @close="recordCloseMethods"
      append-to-body
    >
      <el-table :data="recordList" border>
        <el-table-column
          align="center"
          label="用户ID"
          prop="id"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="唯一编码" prop="icCode">
          <template slot-scope="scope">
            <span>{{ scope.row.icCode }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="变动金额"
          prop="changMoney"
          width="130"
        >
          <template slot-scope="scope">
            <span>{{ jisuan(scope.row.changMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作类型"
          prop="type"
          width="120"
        >
          <template slot-scope="scope">
            <!-- <el-tag>{{}}</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="流水单号"
          prop="columns"
          width="120"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.billCode }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注说明" prop="des" width="120">
          <template slot-scope="scope">
            <span>
              {{ scope.row.des }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作时间"
          prop="createTime"
          width="140"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>

        <div slot="empty" class="empty">
          <span>暂无数据</span>
        </div>
      </el-table>
      <!-- 分页导航区域 -->
      <el-pagination
        @size-change="recordSizeChange"
        @current-change="recordCurrentChange"
        :current-page="recordObj.page"
        :page-sizes="[6, 20, 50, 100]"
        :page-size="recordObj.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordCount"
        background
      >
      </el-pagination>
    </el-dialog>
    <el-dialog
      title="导出"
      :visible.sync="downT"
      width="30%"
      @close="closeMethods"
      append-to-body
      :close-on-click-modal="false"
    >
      <!-- 内容主体区域  -->
      <div>
        <el-date-picker
          type="datetimerange"
          @blur="pickBlur"
          :picker-options="pickerOptions"
          v-model="values"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          @change="changeTime"
        >
        </el-date-picker>
      </div>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeMethods">取 消</el-button>
        <el-button type="primary" v-debounce="upEnter">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 卡片视图区域 直充-->
    <el-card>
      <!-- style="margin-bottom:20px ;" -->
      <li
        style="
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          margin: -10px 0 10px -1%;
        "
      >
        <el-button icon="el-icon-upload2" @click="importElePile"
          >导入</el-button
        >
        <el-button type="primary" icon="el-icon-download" @click="download"
          >导出</el-button
        >
        <el-button type="success" icon="el-icon-plus" @click="showVinAccount"
          >添加</el-button
        >
      </li>
      <!-- table表格区域 -->
      <el-table
        :data="vinAccountList"
        border
        @selection-change="handleSelectionChange"
        @row-dblclick="dbclick"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column align="center" type="expand">
          <template slot-scope="scope">
            <el-form label-position="left" class="demo-table-expand">
              <el-row
                :gutter="20"
                type="flex"
                class="row-bg"
                justify="space-around"
              >
                <el-col :span="8">
                  <el-form-item label="车架号：">
                    <span>{{
                      scope.row.carvin == null ||
                      scope.row.carvin == undefined ||
                      scope.row.carvin == ''
                        ? '--'
                        : scope.row.carvin
                    }}</span>
                  </el-form-item>
                  <el-form-item label="车牌号：">
                    <span>{{
                      scope.row.carNumber == null ||
                      scope.row.carNumber == undefined ||
                      scope.row.carNumber == ''
                        ? '--'
                        : scope.row.carNumber
                    }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="所属公司：">
                    <span>{{
                      scope.row.companyName == null ||
                      scope.row.companyName == undefined ||
                      scope.row.companyName == ''
                        ? '--'
                        : scope.row.companyName
                    }}</span>
                  </el-form-item>
                  <el-form-item label="更新时间：">
                    <span>{{
                      scope.row.updateTime == null ||
                      scope.row.updateTime == undefined ||
                      scope.row.updateTime == ''
                        ? '--'
                        : scope.row.updateTime
                    }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="车牌编号：">
                    <span>{{
                      scope.row.carNumber == null ||
                      scope.row.carNumber == undefined ||
                      scope.row.carNumber == ''
                        ? '--'
                        : scope.row.carNumber
                    }}</span>
                  </el-form-item>
                  <el-form-item label="路别：">
                    <span>{{
                      scope.row.columns == null ||
                      scope.row.columns == undefined ||
                      scope.row.columns == ''
                        ? '--'
                        : scope.row.columns
                    }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="场站名称"
          prop="stationName"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
                            <span>{{ scope.row.stationName }}</span>            
             
          </template>
        </el-table-column>
        <el-table-column align="center" label="车架号" prop="carvin">
          <template slot-scope="scope">
                            <span>{{ scope.row.carvin }}</span>              
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="折扣类型"
          prop="discounType"
          width="130"
          v-if="vinUser"
        >
          <template slot-scope="scope">
            <el-select
              :disabled="tils(scope.row)"
              v-model="scope.row.discounType"
              placeholder="请选择你的vip折扣方式"
              @change="genggai(scope.row, 0)"
            >
              <el-option
                v-for="item in options_active"
                :key="item.discounType"
                :label="item.typeName"
                :value="item.discounType"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="折扣率"
          prop="discountRate"
          width="120"
          v-if="vinUser"
        >
          <template slot-scope="scope">
            <el-select
              :disabled="tils(scope.row)"
              v-model="scope.row.discountRate"
              @change="genggai(scope.row, 1)"
            >
              <el-option
                v-for="item in listType"
                :key="item.value"
                :label="
                  scope.row.discounType == 1 && item.value == 0
                    ? '免收电费'
                    : scope.row.discounType == 2 && item.value == 0
                    ? '免收服务费'
                    : item.name
                "
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" label="路别" prop="columns" width="120">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.columns == null ||
                scope.row.columns == undefined ||
                scope.row.columns == ''
                  ? '--'
                  : scope.row.columns
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="余额"
          prop="money"
          width="120"
          v-if="vinUser"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.payOrNot == 0">
              {{ jisuan(scope.row.money, 100, 2) }}
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="计费方式"
          prop="payOrNot"
          width="140"
          v-if="vinUser"
        >
          <template slot-scope="scope">
            <el-select
              :disabled="!zhekou"
              v-model="scope.row.payOrNot"
              placeholder="请选择你的计费方式"
              @change="tilMethods(scope.row)"
            >
              <el-option
                v-for="item in listall"
                :key="item"
                :label="
                  item == 0 ? '支付' : item == 1 ? '不用支付' : '公司总账户支付'
                "
                :value="item"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="支付账户"
          prop="payName"
          width="140"
          v-if="vinUser"
        >
          <template slot-scope="scope">
            <el-select
              v-if="scope.row.payOrNot == 2"
              :disabled="!zhekou"
              v-model="scope.row.payId"
              placeholder="请选择你的支付账户"
              @change="accountMethods(scope.row)"
            >
              <el-option
                v-for="item in AccountAll"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="状态"
          prop="electricCardState"
          width="80"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.electricCardState"
              :active-color="
                scope.row.electricCardState == 0 ? '#13ce66' : '#ff4949'
              "
              :inactive-color="
                scope.row.electricCardState == 0 ? '#13ce66' : '#ff4949'
              "
              :active-value="1"
              :inactive-value="0"
              :disabled="jinyong"
              @change="change_type(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="操作"
          fixed="right"
          :width="bianji && chongzhituikuan == false ? '400' : '250'"
        >
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="warning" @click="kajilu(scope.row)"
              :disabled="scope.row.k_j_l_anniu">卡记录</el-button> -->
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              :disabled="scope.row.b_j_anniu"
              @click="showVinAccount(scope.row)"
              v-if="caozuoquanxian"
              >编辑</el-button
            >
            <!-- scope.row.payOrNot!==1 && -->
            <el-button
              size="mini"
              icon="el-icon-bangzhu"
              v-if="
                scope.row.payOrNot == 0 &&
                chongzhituikuan == false &&
                caozuoquanxian
              "
              type="success"
              @click="MoneyMethods(scope.row)"
              :disabled="scope.row.payOrNot !== 1 && scope.row.c_z_t_k_anniu"
              >充值/退款</el-button
            >
            <el-button
              size="mini"
              :disabled="scope.row.b_j_anniu"
              @click="detailMethods(scope.row)"
              >用户详情</el-button
            >
            <el-button
              size="small"
              type="danger"
              v-if="delType && caozuoquanxian"
              @click="removeById(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <div slot="empty" class="empty">
          <span>暂无数据</span>
        </div>
      </el-table>
      <!-- 分页导航区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[6, 20, 50, 100]"
        :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import caozuo from '@/utils/pubilc.js'
import { saveBlobToFile } from '@/utils/saveBlobToFile'
export default {
  name: 'vinAccountWorld',
  props: {
    loading: Boolean,
    limit: {
      //限制文件上传个数
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      downT: false,
      vinUser: false,
      actlist: [0, 1, 2, 3, 4, 5],
      extAccept: ['xls', 'xlsx'],
      formData: {
        fileList: [],
      },
      importDialogVisible: false,
      ids_all: 0,
      delType: false,
      kajilu_dialoag: false,
      AccountAll: [],
      radio_value_cz_tk: [
        {
          label: '充值',
          radio: 0,
        },
        {
          label: '退款',
          radio: 1,
        },
      ],
      btn_title: '',
      select_ids: '',
      num: 0,
      radio: 0,
      clis: false,
      bianji: false,
      chongzhituikuan: false,
      zhekou: false,
      suoshudianzhan: '',
      listall: [0, 1, 2],
      indexobj: {
        carVin: 0,
        page: 1,
        limit: 8,
        consumeType: 0,
      },
      DetailBtn: false,
      Detaildialoag: false,
      dialoagBtn: false,
      Moneylist: [],
      total3: 0,
      carInfo: {},
      moren: {},
      powerStationList: [],
      list3: [],
      listindex: 0,
      tupian: this.$imgUrls,
      listobj: {},
      listindex: 0,
      listname: [
        '查看充值记录',
        '查看退款记录',
        '查看赠送金记录',
        '查看即充即退记录',
        '查看绑定金额记录',
        '查看充电记录',
      ],
      editDialogVisible1: false,
      editDialogVisible2: false,
      caozuoquanxian: false,
      // 获取vin用户列表所需参数
      queryInfo: {
        // vin: '',
        carvin: '',
        companyName: '',
        carNumber: '',
        columns: '',
        // startTime: null,
        // endTime: null,
        stationId: null,
        page: 1,
        limit: 6,
        stationIds: window.sessionStorage.getItem('stationIds'),
        roleId: window.sessionStorage.getItem('roleId'),
      },
      // vin用户数据及参数
      vinAccountList: [],
      vinAccountForm: {
        id: null,
        // roadId: null,
        // carNum: null,
        companyName: null,
        power: null,
        userTime: null,
        engineNum: null,
        carvin: null,
        carNumber: null,
        companyId: null,
        powerStationId: null,
        electricCardState: 0,
        stationId: null,
        // adminId: window.sessionStorage.getItem('adminId'),
      },
      vinAccountFormRules: {
        stationId: [
          {
            required: true,
            trigger: 'change',
            message: '请选择直充用户站点',
          },
        ],
        companyName: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入所属公司',
          },
        ],
        carNumber: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入车牌号',
          },
        ],
        carvin: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入车架号',
          },
        ],
        columns: [
          {
            required: false,
            trigger: 'blur',
            message: '请输入路别',
          },
        ],
        selfNumbering: [
          {
            required: false,
            trigger: 'blur',
            message: '请输入自编号',
          },
        ],
      },
      total: 0,
      title: '',
      value: '',
      editDialogVisible: false,
      // 折扣类型
      options_active: [
        {
          discounType: 1,
          typeName: '电费',
        },
        {
          discounType: 2,
          typeName: '服务费',
        },
        {
          discounType: 3,
          typeName: '订单金额',
        },
      ],
      listType: [
        {
          value: 0,
          name: '免费',
        },
        {
          value: 10,
          name: '1折',
        },
        {
          value: 15,
          name: '1.5折',
        },
        {
          value: 20,
          name: '2折',
        },
        {
          value: 25,
          name: '2.5折',
        },
        {
          value: 30,
          name: '3折',
        },
        {
          value: 35,
          name: '3.5折',
        },
        {
          value: 40,
          name: '4折',
        },
        {
          value: 45,
          name: '4.5折',
        },
        {
          value: 50,
          name: '5折',
        },
        {
          value: 55,
          name: '5.5折',
        },
        {
          value: 60,
          name: '6折',
        },
        {
          value: 65,
          name: '6.5折',
        },
        {
          value: 70,
          name: '7折',
        },
        {
          value: 75,
          name: '7.5折',
        },
        {
          value: 80,
          name: '8折',
        },
        {
          value: 85,
          name: '8.5折',
        },
        {
          value: 90,
          name: '9折',
        },
        {
          value: 95,
          name: '9.5折',
        },
        {
          value: 100,
          name: '不打折',
        },
      ],
      expendInfo: {
        page: 1,
        limit: 10,
        electricCardInfoId: null,
      },
      onAccountForm: {},
      // 电站数据
      powerStationOptions: [],
      // 电站所属公司数据
      companyOptions: [
        {
          value: 1,
          label: '公交一公司',
        },
        {
          value: 2,
          label: '公交二公司',
        },
        {
          value: 3,
          label: '公交三公司',
        },
        {
          value: 4,
          label: '公交四公司',
        },
        {
          value: 5,
          label: '焦作市龙源巴士',
        },
      ],
      expendList: [],
      radio_value_JL: [
        {
          ids_all: 0,
          label: '消费记录',
        },
        {
          ids_all: 1,
          label: '操作记录',
        },
      ],
      recordList: [],
      recordObj: {
        payId: null,
        page: 1,
        limit: 10,
      },
      recordCount: 0,
      recordTil: false,
      powerOptions: [],
      ids: '',
      stationList: [],
      goMoneyDialoag: false,
      jinyong: false,
      active: {},
      ids_all: 0,
      expendTotal: 0,
      activeIndex: 0,
      startTime: '',
      endTime: '',
      pickerMinDate: '',
      pickerOptions: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime()
          const start = this.formatDate(obj.minDate, 'start')
          const end = this.formatDate(obj.maxDate, 'end')
          obj.maxDate && (this.values = [start, end])
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const oneMonth = 1000 * 3600 * 24 * 31
            const maxTime = this.pickerMinDate + oneMonth
            const mixTime = this.pickerMinDate - oneMonth + 1000 * 3600 * 24
            const tomorrow = new Date(
              this.formatDate(new Date().getTime() + 1000 * 3600 * 24, 'start')
            )
            return (
              time.getTime() >= tomorrow ||
              time.getTime() >= maxTime ||
              time.getTime() < mixTime
            )
          }
        },
      },
      values: ['', ''],
    }
  },
  computed: {
    tils() {
      return function (obj) {
        return !this.zhekou || obj.payOrNot > 0 ? true : false
      }
    },
    extAcceptStr() {
      return this.extAccept.map((ext) => `.${ext}`).join(',')
    },
    shiji() {
      return function (abc, bac) {
        return abc == null || abc == undefined
          ? '---'
          : ((abc * 1 + bac * 1) / 100).toFixed(2)
      }
    },
    wait_s() {
      return function (e) {
        return ((e.money - e.giveMoney) / 100).toFixed(2)
      }
    },
    time_all() {
      return function (val) {
        const hr = val.billCode.slice(val.pileCode.length, val.billCode.length)
        return hr
      }
    },
    jisuan() {
      return function (obj, num, fixed) {
        return obj == null || obj == undefined
          ? '0'
          : (obj / num).toFixed(fixed)
      }
    },
    shifu() {
      return function (val) {
        return ((val.billMoney - val.billMoneygive) / 100).toFixed(2)
      }
    },
  },
  created() {
    caozuo(228).then((res) => {
      this.vinUser = res
      console.log(res, '973')
    })
    // this.jinyong = window.sessionStorage.getItem('roleId') == 1 ? false : true;
    caozuo(100).then((res) => {
      this.caozuoquanxian = res
      this.bianji = res
      this.jinyong = !res
    })
    caozuo(219).then((res) => {
      this.zhekou = res
    })
    caozuo(220).then((res) => {
      this.chongzhituikuan = !res
    })
    caozuo(224).then((res) => {
      this.delType = res
    })
    this.com4()
    this.powerStationList = []
    let acc = {
      roleId: window.sessionStorage.getItem('roleId'),
      stationIds: window.sessionStorage.getItem('stationIds'),
      stationMode: '0,1,2',
    }
    if (
      window.sessionStorage.getItem('roleId') == 1 ||
      window.sessionStorage.getItem('roleId') == 2 ||
      window.sessionStorage.getItem('roleId') == 3 ||
      window.sessionStorage.getItem('roleId') == 10
    ) {
      if (
        !this.suoshudianzhan ||
        this.suoshudianzhan == '' ||
        this.suoshudianzhan == undefined
      ) {
        this.$delete(acc, 'stationIds')
      }
    } else {
      if (
        !this.suoshudianzhan ||
        this.suoshudianzhan == '' ||
        this.suoshudianzhan == undefined
      ) {
        this.queryInfo.stationIds = window.sessionStorage.getItem('stationIds')
      }
    }
    this.$http
      .get('station-info/getAllStationInfoName', {
        params: acc,
      })
      .then((resb) => {
        if (resb.data.code == 0) {
          resb.data.data.forEach((item) => {
            this.powerStationList.push({
              id: item.id,
              stationName: item.stationName,
            })
          })
        }
      })
    this.getVinAccountList()
  },
  methods: {
    pickBlur() {
      this.pickerMinDate = ''
    },
    formatDate(datetime, type) {
      const time = new Date(datetime)
      const year = time.getFullYear()
      const month = (time.getMonth() + 1).toString().padStart(2, '0')
      const date = time.getDate().toString().padStart(2, '0')
      return type === 'start'
        ? year + '-' + month + '-' + date + ' ' + '00' + ':' + '00' + ':' + '00'
        : year + '-' + month + '-' + date + ' ' + '23' + ':' + '59' + ':' + '59'
    },
    getDate() {
      const start = new Date()
      this.values[0] = this.formatDate(
        start.getTime() - 1000 * 3600 * 24 * 30,
        'start'
      )
      this.values[1] = this.formatDate(start.getTime(), 'end')
    },
    changeTime(value) {
      if (value) {
        this.startTime = value[0]
        this.endTime = value[1]
        if (this.startTime == this.endTime) {
          this.$message.error('起始时间不得为同一天！')
          this.startTime = ''
          this.endTime = ''
        }
      } else {
        this.startTime = null
        this.endTime = null
        this.pickerMinDate = ''
      }
    },
    chaxun() {
      this.queryInfo.page = 1
      this.getVinAccountList()
    },
    //
    recordSizeChange(newSize) {
      this.recordObj.limit = newSize
      this.recordMethods()
    },
    //
    recordCurrentChange(newPage) {
      this.recordObj.page = newPage
      this.recordMethods()
    },
    // 关闭
    recordCloseMethods() {
      this.recordTil = false
      this.recordCount = 0
      this.recordList = []
    },
    download() {
      this.downT = true
    },
    upEnter() {
      // 验证基础参数
      if (!this.startTime || !this.endTime) {
        return this.$message.error('请选择导出时间')
      }

      // 获取通用参数
      const baseParams = {
        startTime: this.startTime,
        endTime: this.endTime,
        adminId: Number(window.sessionStorage.getItem('adminId')),
        startType: 4,
        isMain: 0,
      }

      // 处理所属电站存在的情况
      if (this.suoshudianzhan) {
        const params = { ...baseParams }
        if (this.hasSelectedUser()) {
          const user = this.getSelectedUser()
          if (!user) return

          Object.assign(params, {
            stationIds: user.stationId,
            cardsId: user.cardsId,
            icCode: user.icCode,
            carNum: user.carNumber,
          })
        } else {
          params.stationIds = this.suoshudianzhan
        }

        return this.com2(params)
      }

      // 处理所属电站不存在的情况
      return this.handleNoStation(baseParams)
    },

    // 辅助方法：检查是否选择了用户
    hasSelectedUser() {
      return this.ids != null && this.ids !== '' && this.ids !== undefined
    },

    // 辅助方法：获取选中的用户信息
    getSelectedUser() {
      const users = this.vinAccountList.filter((item) => item.id == this.ids)
      return users.length > 0 ? users[0] : null
    },
    // 辅助方法：处理无电站情况
    handleNoStation(baseParams) {
      const roleId = window.sessionStorage.getItem('roleId')
      const isSpecialRole = ['1', '2', '3', '10'].includes(roleId)

      if (isSpecialRole) {
        if (!this.hasSelectedUser()) {
          return this.$message.error(
            '导出场站请选择该场站的所有用户,单人导出需勾选导出的用户'
          )
        }
      }

      const user = this.getSelectedUser()
      if (!user && !isSpecialRole) {
        baseParams.stationIds = window.sessionStorage.getItem('stationIds')
      } else if (user) {
        Object.assign(baseParams, {
          stationIds: user.stationId,
          cardsId: user.cardsId,
          icCode: user.icCode,
          carNum: user.carNumber,
        })
      }

      return this.com2(baseParams)
    },
    com2(obj) {
      this.$http
        .get('bill-info/export', {
          responseType: 'blob',
          params: obj,
        })
        .then((res) => {
          if (res.headers['content-type']?.includes('application/json')) {
            this.$message.error('无符合条件的订单！')
          } else {
            saveBlobToFile(res.data, '直充用户消费列表')
            this.$message.success('文件导出成功')
          }
        })
    },
    closeMethods() {
      this.downT = false
      this.values = ['', '']
      this.startTime = ''
      this.endTime = ''
    },
    importElePile() {
      this.importDialogVisible = true
    },
    async onSubmit() {
      var formData = new FormData()
      let abc = ''
      if (
        window.sessionStorage.getItem('roleId') == 1 ||
        window.sessionStorage.getItem('roleId') == 2 ||
        window.sessionStorage.getItem('roleId') == 3 ||
        window.sessionStorage.getItem('roleId') == 10
      ) {
        if (this.ids == '' || this.ids == null)
          return this.$message.error('请勾选需要导入用户的单选框')
        abc = this.vinAccountList.filter((item) => {
          return item.id == this.ids
        })[0].stationId
      } else {
        if (window.sessionStorage.getItem('stationIds').includes(',')) {
          if (this.ids == '' || this.ids == null)
            return this.$message.error('请勾选需要导入用户的单选框')
          abc = this.vinAccountList.filter((item) => {
            return item.id == this.ids
          })[0].stationId
        } else {
          abc = window.sessionStorage.getItem('stationIds')
        }
      }
      for (const file of this.formData.fileList) {
        //多个文件全部都放到files
        if (file.raw) {
          formData.append('file', file.raw)
          formData.append('stationId', abc)
          formData.append(
            'adminId',
            window.sessionStorage.getItem('adminId') * 1
          )
        }
      }
      const { data: res } = await this.$http.post(
        'charge-vin/importVin',
        formData
      )
      this.importDialogVisible = false
      this.ids = ''
      this.$message({
        message: res.msg,
        type: res.data.code == 0 ? 'success' : 'error',
      })
    },
    onFileMove(file, fileList) {
      this.formData.fileList = fileList
    },
    onFileExceed() {
      this.$message.error(`仅允许上传 ${this.limit} 个文件！`)
    },
    validateFile(file) {
      if (!file) return '至少添加一个文件！'
      const ext = (file.name || '').split('.')[1]
      if (!this.extAccept.includes(ext))
        return `仅支持${this.extAcceptStr}格式的文件`
      return ''
    },
    // 选择文件的改变事件
    onFileChange(file, fileList) {
      const errMsg = this.validateFile(file)
      if (errMsg) {
        this.$message.error(errMsg)
        this.formData.fileList.splice(0, 1)
      } else {
        this.formData.fileList = fileList
      }
    },
    onAfterClose() {
      this.formData = {
        fileList: [],
      }
    },
    onClose() {
      this.importDialogVisible = false
    },
    com4() {
      let acc = {
        page: 1,
        limit: 100,
        adminId: window.sessionStorage.getItem('adminId'),
        stationIds: window.sessionStorage.getItem('stationIds'),
        roleId: window.sessionStorage.getItem('roleId'),
      }
      if (
        window.sessionStorage.getItem('roleId') == 1 ||
        window.sessionStorage.getItem('roleId') == 2 ||
        window.sessionStorage.getItem('roleId') == 3 ||
        window.sessionStorage.getItem('roleId') == 10
      ) {
        if (
          !this.suoshudianzhan ||
          this.suoshudianzhan == '' ||
          this.suoshudianzhan == undefined
        ) {
          this.$delete(acc, 'stationIds')
        }
      }
      this.$http
        .get('charge-vin-total/getAllChargeVinTotal', {
          params: acc,
        })
        .then((rese) => {
          const res = rese.data
          this.AccountAll =
            res.code > 0
              ? []
              : res.data.map((item) => ({
                  ...item,
                  payOrNot: Number(item.payOrNot),
                }))
        })
    },
    // 监听pageSize改变的事件
    expendSizeChange(newSize) {
      this.expendInfo.limit = newSize
      this.getExpendList()
    },
    // 监听页码值改变的事件
    expendCurrentChange(newPage) {
      this.expendInfo.page = newPage
      this.getExpendList()
    },
    async getExpendList() {
      const { data: res } = await this.$http.get(
        'electric-card-info/getRecordsList',
        {
          params: this.expendInfo,
        }
      )
      if (res.code !== 0) return this.$message.error(res.msg)
      console.log(res)
      this.$message.success('获取在线卡用户消费列表成功！')
      this.expendList = res.data
      this.expendTotal = res.count
    },
    async change_input_card(e) {
      this.expendList = []
      this.caozuojiluList = []
      if (e == 0) {
        const { data: res } = await this.$http.get(
          'electric-card-info/getRecordsList',
          {
            params: this.expendInfo,
          }
        )
        if (res.code !== 0) return
        this.expendList = res.data
        this.expendTotal = res.count
      } else {
        //操作记录
        this.caozuojiluInfo.electricCardInfoId =
          this.caozuojiluInfo.physicalCode
        this.caozuojiluInfo.physicalCode = null
        await this.$http
          .get('electric-card-info/getOperationRecordsList', {
            params: this.caozuojiluInfo,
          })
          .then((resb) => {
            if (resb.data.code !== 0) return
            this.caozuojiluList = resb.data.data
            this.caozuojiluTotal = resb.data.count
          })
      }
    },
    kajilu_dialoagClosed() {
      this.kajilu_dialoag = false
      this.ids_all = 0
    },
    change_input(e) {
      this.num = 0
      console.log(this.onAccountForm, '414')
      if (e == 1) {
        this.btn_title = '退款'
      } else {
        this.btn_title = '充值'
      }
    },
    // 关闭：充值、退款弹窗
    clisClosed() {
      this.clis = false
    },
    // 打开：充值、退款弹窗
    async MoneyMethods(row) {
      this.num = 0
      const { data: res } = await this.$http.get(
        '/charge-vin/getChargeVinById/' + row.id
      )
      if (res.code !== 0) return (row.c_z_t_k_anniu = false)
      row.c_z_t_k_anniu = true
      this.onAccountForm = res.data
      this.select_ids = row.id
      this.clis = true
    },
    // 充值\退款事件
    clis_ok() {
      const that = this
      if (that.num < 1) {
        return that.$message({
          message: '充值或退款金额必须大于1',
          type: 'warning',
        })
      }
      if (that.radio == 0) return that.com1()
      that.$http
        .get('charge-user-info/getBillByPublicVinId/' + that.select_ids)
        .then((res2) => {
          if (res2.data.code > 0)
            return that.$message.$error(
              '子账户有正在充电中的账单！请结束后再进行退款'
            )
          that.$http
            .get('charge-user-info/getParkBillByPublicVinId/' + that.select_ids)
            .then((res3) => {
              if (res3.data.code > 0)
                return that.$message.$error(
                  '子账户有正在占位中的账单！请结束后再进行退款'
                )
              that.com1()
            })
        })
    },
    com1() {
      const that = this
      that.$http
        .post(
          'charge-vin/updRechargeMoneyById?id=' +
            that.select_ids +
            '&money=' +
            (that.num * 100).toFixed(0) +
            '&adminId=' +
            window.sessionStorage.getItem('adminId') +
            '&type=' +
            that.radio
        )
        .then((res4) => {
          if (res4.data.code !== 0) {
            that.$message.error(`${that.radio == 0 ? '充值' : '退款'}失败`)
          } else {
            that.$message.success(
              that.radio == 0
                ? `vin用户${that.radio == 0 ? '充值' : '退款'}成功！`
                : `vin用户${that.radio == 0 ? '充值' : '退款'}失败！`
            )
            that.getVinAccountList()
          }
          that.clis = false
          that.radio = 0
        })
    },
    // 更改用户计费方式
    async tilMethods(row) {
      try {
        // 1. 检查充电账单
        const chargingRes = await this.checkChargingBill(row.id)
        if (chargingRes.hasBills) return

        // 2. 检查占位账单
        const parkingRes = await this.checkParkingBill(row.id)
        if (parkingRes.hasBills) return

        // 3. 处理特殊支付状态
        if (row.payOrNot > 0) {
          await this.handleSpecialPayment(row, 0)
        }

        // 4. 确保有子账户（仅当支付状态为2时）
        if (row.payOrNot === 2 && this.AccountAll.length === 0) {
          await this.getVinAccountList()
          return
        }

        // 5. 执行计费方式更新
        const updateRes = await this.updateChargeMethod(row)
        this.showMessage(updateRes)
        this.getVinAccountList()
      } catch (error) {
        console.log('计费方式更新失败:', error)
        this.$message.error(error)
      }
    },

    // 检查充电账单
    async checkChargingBill(id) {
      const res = await this.$http.get(
        `charge-user-info/getBillByPublicVinId/${id}`
      )
      if (res.data.code > 0) {
        this.getVinAccountList()
        throw new Error('子账户有正在充电中的账单！请结束后再更改计费方式')
      }
      return { hasBills: false }
    },

    // 检查占位账单
    async checkParkingBill(id) {
      const res = await this.$http.get(
        `charge-user-info/getParkBillByPublicVinId/${id}`
      )
      if (res.data.code > 0) {
        this.getVinAccountList()
        throw new Error('子账户有正在占位中的账单！请结束后再更改计费方式')
      }
      return { hasBills: false }
    },

    // 处理特殊支付状态
    async handleSpecialPayment(row, val) {
      await this.genggai(row, val)
    },

    // 更新计费方式
    async updateChargeMethod(row) {
      const res = await this.$http.post('charge-vin/updateChargeVinById', {
        id: row.id,
        roleId: window.sessionStorage.getItem('roleId'),
        adminId: window.sessionStorage.getItem('adminId'),
        payOrNot: row.payOrNot,
      })
      return res
    },

    // 统一消息展示
    showMessage(res) {
      const type = res.data.code === 0 ? 'success' : 'error'
      this.$message({
        message:
          res.data.code === 0 ? '用户计费方式修改成功' : '用户计费方式修改失败',
        type: type,
      })
    },
    // 支付账户账户更改
    accountMethods(row) {
      if (row.payId == 0) return this.getVinAccountList()
      this.$http
        .post('charge-vin/updateChargeVinById', {
          id: row.id,
          roleId: window.sessionStorage.getItem('roleId'),
          adminId: window.sessionStorage.getItem('adminId'),
          payOrNot: row.payOrNot,
          payId: row.payId * 1,
        })
        .then((res) => {
          const res1 = res.data
          this.$message({
            type: res1.code > 0 ? 'error' : 'success',
            message: res1.code > 0 ? '支付账户修改失败' : '支付账户修改成功',
          })
        })
    },
    // 批量修改用户Vip
    genggai(row, type) {
      this.active.ids = String(row.id)
      this.active.discounType = row.discounType
      this.active.discountRate =
        type !== 0 && row.payOrNot == 0 ? row.discountRate : 100
      console.log(type, row.payOrNot, 1041)
      this.$http
        .post(
          `charge-vin/updateVIPByIds?ids=${this.active.ids}&discounType=${
            this.active.discounType
          }&discountRate=${this.active.discountRate}&adminId=${
            window.sessionStorage.getItem('adminId') * 1
          }`
        )
        .then((res) => {
          this.$message({
            message: res.data.msg,
            type: res.data.code == 0 ? 'success' : 'error',
          })
          this.getVinAccountList()
          if (res.data.code == 0) return (this.active = {})
        })
    },
    change_value(e) {
      this.queryInfo.page = 1
      if (e !== null || e !== undefined) {
        this.queryInfo.stationIds = e
        this.getVinAccountList()
      }
    },
    // 历史记录
    handleSizeChange3(newSize) {
      this.indexobj.limit = newSize
      this.indexobj.page = 1
      this.getIndex()
    }, // 历史记录
    handleCurrentChange3(newPage) {
      this.indexobj.page = newPage
      this.getIndex()
    },
    getIndex() {
      const that = this
      that.list3 = []
      that.$http
        .get('charge-user-info/getAllBillByUserId', {
          params: that.indexobj,
        })
        .then((res) => {
          if (res.data.code !== 0) return
          that.list3 = res.data.data
        })
    },
    // 详情
    detailMethods(e) {
      const that = this
      that.indexobj.carVin = e.carvin
      that.recordObj.payId = e.id
      that.$http.get(`charge-vin/getChargeVinById/${e.id}`).then((res) => {
        if (res.data.code !== 0) return
        that.listobj = res.data.data
        that.tanceng()
        that.carInfo = {
          payId: e.id,
          usingType: 0,
          billInfoType: 2,
          adminId: window.sessionStorage.getItem('adminId'),
          page: 1,
          limit: 8,
          userNumber: e.userNumber,
          billCode: e.billCode,
          pileCode: e.pileCode,
          consumeType: 0,
          type: 2,
        }
      })
    },
    MoneyDialoag2() {
      this.dialoagBtn = false
    },
    tanceng() {
      this.Detaildialoag = true
    },
    // 充值、退款、消费、欠费记录
    recodes(val) {
      this.activeIndex = val
      if (val == 5) return this.listMethods()
      this.recordObj.usingType = val
      this.recordObj.isMain = 1
      this.recordMethods()
    },
    recordMethods() {
      this.$http
        .get('charge-vin-consume-log/getAllChargeVinConsumeLog', {
          params: this.recordObj,
        })
        .then((res) => {
          this.recordTil = true
          if (res.data.code > 0) return
          this.recordList = res.data.data
          this.recordCount = res.data.count
        })
    },
    // 充电记录
    listMethods() {
      const that = this
      that.$http
        .get('charge-user-info/getAllBillByUserId', {
          params: that.indexobj,
        })
        .then((ress) => {
          if (ress.data.code !== 0) return
          that.list3 = ress.data.data
          that.total3 = ress.data.count
          that.moren = {
            totalBillMoney: ress.data.data[0].totalBillMoney,
            totalChargeMoney: ress.data.data[0].totalChargeMoney,
            totalDiscountMoney: ress.data.data[0].totalDiscountMoney,
            totalServiceMoney: ress.data.data[0].totalServiceMoney,
            totalBillKwhs: ress.data.data[0].totalBillKwhs,
            totalLengthTime: ress.data.data[0].totalLengthTime,
            totalBillCount: ress.data.data[0].totalBillCount,
          }
        })
      that.dialoagBtn = true
    },
    // 用户详情
    editDialogClosed1() {
      this.editDialogVisible1 = false
    },
    // 充电历史订单
    editDialogClosed2() {
      this.editDialogVisible2 = false
    },
    current() {
      this.queryInfo.page = 1
    },
    chongzhi() {
      this.queryInfo = {
        carvin: '',
        companyName: '',
        carNumber: '',
        stationId: null,
        page: 1,
        limit: 6,
        stationIds: window.sessionStorage.getItem('stationIds'),
        roleId: window.sessionStorage.getItem('roleId'),
      }
      this.suoshudianzhan = ''
      this.getVinAccountList()
    },
    // 获取vin用户列表
    async getVinAccountList() {
      if (
        window.sessionStorage.getItem('roleId') == 1 ||
        window.sessionStorage.getItem('roleId') == 2 ||
        window.sessionStorage.getItem('roleId') == 3 ||
        window.sessionStorage.getItem('roleId') == 10
      ) {
        if (
          !this.suoshudianzhan ||
          this.suoshudianzhan == '' ||
          this.suoshudianzhan == undefined
        ) {
          this.$delete(this.queryInfo, 'stationIds')
        }
      } else {
        if (
          !this.suoshudianzhan ||
          this.suoshudianzhan == '' ||
          this.suoshudianzhan == undefined
        ) {
          this.queryInfo.stationIds =
            window.sessionStorage.getItem('stationIds')
        }
      }
      this.queryInfo.roleId=window.sessionStorage.getItem('roleId');
      const { data: res } = await this.$http.get('charge-vin/getAllChargeVin', {
        params: this.queryInfo,
      })
      this.vinAccountList = res.code > 0 ? [] : res.data
      if (res.code == 0) {
        this.vinAccountList.forEach((item) => {
          item.b_j_anniu = false
          item.payId = item.payId == 0 ? '' : item.payId
        })
      }
      this.total = res.count
      if (res.code !== 0) {
        this.$message.error(res.msg)
      }
    },
    // 修改直充账户状态
    async change_type(row) {
      await this.$http
        .post('charge-vin/updateChargeVinById', {
          ...row,
          adminId:window.sessionStorage.getItem('adminId')
        })
        .then((res) => {
          this.$message.success(res.data.msg)
          this.getVinAccountList()
        })
    },
    // 双击展开事件
    dbclick(row, column, event) {
      if (event.currentTarget.querySelector('.el-table__expand-icon')) {
        event.currentTarget.querySelector('.el-table__expand-icon').click()
      }
    },
    // 监听pageSize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryInfo.page = 1
      this.getVinAccountList()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getVinAccountList()
    },
    // 展示添加&编辑直充用户对话框
    async showVinAccount(row) {
      this.powerStationOptions = []
      this.editDialogVisible = true
      let a = null
      if (window.sessionStorage.getItem('stationIds') == null) {
        a = null
      } else {
        a = window.sessionStorage.getItem('stationIds')
      }
      let abc = {
        roleId: window.sessionStorage.getItem('roleId'),
        stationMode: '0,1,2',
        stationIds: window.sessionStorage.getItem('stationIds'),
      }
      const roleId = window.sessionStorage.getItem('roleId')
      if (roleId == 1 || roleId == 2 || roleId == 3 || roleId == 10) {
        this.$delete(abc, 'stationIds')
      }
      const { data: res } = await this.$http.get(
        'station-info/getAllStationInfoName',
        {
          params: abc,
        }
      )
      this.stationList = res.data

      // if (res.code !== 0) return this.$message.error(res.msg)
      // res.data.forEach(item => {
      //   const obj = {
      //     label: '',
      //     value: ''
      //   }
      //   obj.label = item.name
      //   obj.value = item.id
      //   this.powerStationOptions.push(obj)
      // })
      if (row.id === undefined || row.id === null) {
        this.title = '添加直充用户'
      } else {
        this.title = '编辑直充用户'
        const { data: res } = await this.$http.get(
          'charge-vin/getChargeVinById/' + row.id
        )
        if (res.code !== 0) {
          row.b_j_anniu = false
          this.$message.error(res.msg)
        } else {
          row.b_j_anniu = true
          this.vinAccountForm = res.data
        }
      }
    },
    // 添加&编辑直充用户事件
    editVinAccount() {
      this.$refs.vinAccountFormRef.validate(async (valid) => {
        if (!valid) return
        this.vinAccountForm.adminId =
          window.sessionStorage.getItem('adminId') * 1;
        
        if (this.title == '添加直充用户') {
          this.$http
            .post('charge-vin/exist', {
              data: {
                carNumber: this.vinAccountForm.carNumber,
                carvin: this.vinAccountForm.carvin,
                stationId: this.vinAccountForm.stationId,
                roleId:window.sessionStorage.getItem('roleId')
              },
            })
            .then((res) => {
              const resn = res.data;
              if (resn.code > 0){
                this.$message.error('该用户已存在,请勿重复添加！');
                return;
              }
              this.com1s()
            })
        } else {
          this.com1s()
        }
      })
    },
    async com1s() {
      const { data: res } = await this.$http.post(
        this.title == '添加直充用户'
          ? 'charge-vin/addChargeVin'
          : 'charge-vin/updateChargeVinById',
        this.vinAccountForm
      )
      if (res.code !== 0) return this.$message.error(res.msg)
      this.$message.success(`${this.title}成功！`)
      this.getVinAccountList()
      this.editDialogVisible = false
    },
    // 添加&编辑直充用户对话框关闭事件
    editDialogClosed() {
      this.$refs.vinAccountFormRef.resetFields()
      this.editDialogVisible = false
      this.vinAccountList.forEach((element) => {
        element.b_j_anniu = false
      })
    },
    // 批量删除的复选框改变事件
    handleSelectionChange(value) {
      if (value.length > 0) {
        this.ids = ''
        value.forEach((item) => {
          this.ids += item.id + ','
        })
        this.ids = this.ids.substring(0, this.ids.length - 1)
      } else {
        return false
      }
    },
    // 删除vin用户方法
    async removeById(row) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除该VIN用户, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消删除！')
      }
      if (row.id === null || row.id === '' || row.id === undefined) {
        const { data: res } = await this.$http.get(
          'charge-vin/del/' +
            this.ids +
            '/' +
            window.sessionStorage.getItem('adminId')
        )
        if (res.code !== 0) {
          return this.$message.error('删除VIN用户失败！')
        }
        this.$message.success('删除VIN用户成功！')
        this.getVinAccountList()
      } else {
        const { data: res } = await this.$http.get(
          'charge-vin/del/' +
            row.id +
            '/' +
            window.sessionStorage.getItem('adminId')
        )
        if (res.code !== 0) {
          return this.$message.error('删除VIN用户失败！')
        }
        this.$message.success('删除VIN用户成功！')
        this.getVinAccountList()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.moneylist {
  height: 180px;
  display: flex;
  flex-direction: row;

  dl {
    flex: 1;
    display: flex;
    flex-direction: column;

    p {
      flex: 1;
      display: flex;
      align-items: center;
    }
  }
}

.cardslist {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .top,
  .center {
    flex: 2;
    display: flex;
    flex-direction: column;

    dl {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      dt {
        // flex: 2;
        width: 200px;
        display: flex;
        align-items: center;
      }

      dd {
        // flex: 8
        width: calc(100% - 200px);
      }
    }
  }

  .top {
    font-size: 16px;

    dd {
      display: flex;
      flex-direction: row;

      li {
        flex: 1;
        display: flex;
        flex-direction: column;

        p {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }

      li:nth-child(2) {
        span:nth-child(1) {
          width: 160px;
        }
      }
    }
  }

  .center {
    border-bottom: 1px solid gray;
    border-top: 1px solid gray;
    padding-bottom: 20px;

    dl {
      flex: 9;
    }

    dd {
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        flex-direction: row;

        p {
          margin-right: 30px;
          display: flex;
          flex-direction: column;

          span:nth-child(1) {
            font-size: 16px;
            width: 125px;
            color: gray;
          }

          span:nth-child(2) {
            color: blue;
            font-size: 32px;
            display: flex;
            margin-top: 10px;
            justify-content: center;
          }
        }
      }
    }

    .footername {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;

      span {
        flex: 1;
        color: blue;
      }
    }
  }

  .bottom {
    display: flex;
    flex-direction: column;
    font-size: 16px;

    h4 {
      padding: 20px 0;
    }
  }

  .center,
  .bottom.top {
    flex: 3;
  }

  .footer {
    flex: 1;
    display: flex;
    flex-direction: column;
    font-size: 16px;

    li {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      p {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }
}

.listname {
  display: flex;
  flex-direction: row;
  height: 120px;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 20px;
  border: 1px solid gray;
  list-style: none;
  border-radius: 15px;

  .dl {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-right: 20px;

    p {
      flex: 1;
      display: flex;
      justify-content: center;
      font-size: 18px;
    }

    p:nth-child(1) {
      color: gray;
      font-size: 16px;
    }
  }

  .dl:last-child {
    margin-right: 0;
  }
}
</style>
